import { render } from "./EmpAssignedl.vue?vue&type=template&id=e51a5de6"
import script from "./EmpAssignedl.vue?vue&type=script&lang=js"
export * from "./EmpAssignedl.vue?vue&type=script&lang=js"

import "./EmpAssignedl.vue?vue&type=style&index=0&id=e51a5de6&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__